/*
 * @Author: your name
 * @Date: 2021-08-04 15:25:39
 * @LastEditTime: 2021-12-04 16:59:13
 * @LastEditors: lks
 * @Description: In User Settings Edit
 */
import { RouteConfig } from 'vue-router';
import PView from '../layouts/view.vue';

const articleRoute: RouteConfig[] = [
  {
    path: '/article.html',
    redirect: '/help.html',
  },
  {
    path: '/help',
    component: PView,
    redirect: '/help.html',
    children: [
      {
        path: '/help.html',
        name: 'article',
        component: () => import('@/views/article/index.vue'),
        meta: { title: '', parentTab: 'article' },
      },
    ],
  },
  {
    path: '/help/search',
    component: PView,
    redirect: '/help/search.html',
    children: [
      {
        path: '/help/search.html',
        name: 'helpSearch',
        component: () => import('@/views/article/search.vue'),
        meta: { title: '帮助与支持-搜索', parentTab: 'article' },
      },
    ],
  },
];

export { articleRoute };
